import { render } from "./ToolBarLiquor.vue?vue&type=template&id=1dcfc8ac"
import script from "./ToolBarLiquor.vue?vue&type=script&lang=js"
export * from "./ToolBarLiquor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__